<template>
  <CCard>
    <!-- Header -->
    <CCardHeader class="d-flex justify-content-between align-items-center">
      <CButton color="primary" class="mr-2" @click="goBack">← Back</CButton>
      <h2>Gym Subscriptions</h2>
      <CButton color="primary" @click="addSubscription">Add Subscription</CButton>
    </CCardHeader>

    <CCardBody>
      <CDataTable :items="subscriptions" :fields="fields" :loading="loading">
        <template #active="row">
          <td>
            <span :class="row.item.active ? 'badge bg-success' : 'badge bg-secondary'">
              {{ row.item.active ? 'Yes' : 'No' }}
            </span>
          </td>
        </template>

        <template #starts_at="row">
          <td>{{ formatLocalDate(row.item.starts_at) }}</td>
        </template>

        <template #ends_at="row">
          <td>{{ formatLocalDate(row.item.ends_at) }}</td>
        </template>

        <template #actions="row">
          <td>
            <div class="d-flex flex-column gap-3">
              <CButton
                v-if="row.item.stripe_status === 'manual'"
                size="sm"
                color="warning"
                class="mb-2 text-white"
                @click="editSubscription(row.item.id)"
              >
                Edit
              </CButton>
              <CButton
                v-if="row.item.stripe_status === 'manual'"
                size="sm"
                color="danger"
                class="mb-2 text-white"
                @click="deleteSubscription(row.item.id)"
              >
                Delete
              </CButton>
            </div>
          </td>
        </template>
      </CDataTable>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: 'GymSubscriptions',
  data() {
    return {
      gymId: null,
      subscriptions: [],
      fields: [
        { key: 'name', label: 'Name' },
        { key: 'stripe_status', label: 'Status' },
        { key: 'starts_at', label: 'Start' },
        { key: 'ends_at', label: 'Ends' },
        { key: 'active', label: 'Active' },
        { key: 'actions', label: 'Actions', _style: { width: '150px' }, sorter: false },
      ],
      loading: false,
    };
  },
  mounted() {
    this.gymId = this.$route.params.gymId;
    this.fetchSubscriptions();
  },
  methods: {
    fetchSubscriptions() {
      this.loading = true;
      this.$http
        .get(`/gym/${this.gymId}/gym-subscriptions`)
        .then(({ data }) => {
          this.subscriptions = data.subscriptions
            .map((s) => ({
              ...s,
              active: this.isActiveSubscription(s.starts_at, s.ends_at),
            }))
            .sort((a, b) => b.active - a.active);
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },

    isActiveSubscription(start, end) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      const startDate = new Date(start);
      startDate.setHours(0, 0, 0, 0);
      const endDate = new Date(end);
      endDate.setHours(0, 0, 0, 0);
      return today >= startDate && today <= endDate;
    },

    addSubscription() {
      this.$router.push(`/gyms/${this.gymId}/subscriptions/new`);
    },

    editSubscription(subscriptionId) {
      this.$router.push(`/gyms/${this.gymId}/subscriptions/${subscriptionId}/edit`);
    },

    deleteSubscription(subscriptionId) {
      if (!confirm('Are you sure you want to delete this subscription?')) return;
      this.$http.delete(`/gym/${this.gymId}/gym-subscriptions/${subscriptionId}`).then(() => {
        this.$toast.success('Subscription deleted!');
        this.fetchSubscriptions();
      });
    },
    formatLocalDate(dateString) {
      if (!dateString) return '—';
      const [datePart] = dateString.split(' ');
      const [year, month, day] = datePart.split('-');

      const date = new Date(year, month - 1, day);
      return date.toLocaleDateString();
    },
    goBack() {
      this.$router.push('/gyms');
    },
  },
};
</script>

<style scoped>
.badge.bg-success {
  background-color: #28a745;
  color: white;
}
.badge.bg-secondary {
  background-color: #6c757d;
  color: white;
}
</style>
